module.exports = __webpack_public_path__ + "static/media/appsIcon.2b655d32.svg";